import {createSlice} from "@reduxjs/toolkit";

const initialLinksState = {
  listLoading: false,
  actionsLoading: false,
  totalCount: 0,
  orderList: null,
  order: undefined,
  lastError: null
};

export const callTypes = {
  list: "list",
  action: "action"
};

export const ordersSlice = createSlice({
  name: "orders",
  initialState: initialLinksState,
  reducers: {
    catchError: (state, action) => {
      state.error = `${action.type}: ${action.payload.error}`;
      if (action.payload.callType === callTypes.list) {
        state.listLoading = false;
      } else {
        state.actionsLoading = false;
      }
    },

    startCall: (state, action) => {
      state.error = null;
      if (action.payload.callType === callTypes.list) {
        state.listLoading = true;
      } else {
        state.actionsLoading = true;
      }
    },

    // findLinks
    ordersFetched: (state, action) => {
      const { totalCnt, orderList } = action.payload;
      state.listLoading = false;
      state.error = null;
      state.orderList = orderList;
      state.totalCount = totalCnt;
    },

    // getLinkById
    orderFetched: (state, action) => {
      const {order} = action.payload;
      state.actionsLoading = false;
      state.order = order;
      state.error = null;
    },
  }
});
